import React from "react";
import styles from "./style.module.css";
import freedataim from "../../../assets/images/freedataim.png";
import Seamless from "../../../assets/images/Seamless.png";
import Seamless1 from "../../../assets/images/Seamless1.png";
import Seamless2 from "../../../assets/images/Seamless2.png";

function ChooseSim() {
  return (
     <section className={`${styles.Travelers_commbitz} `}>
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6 py-2">
              <h4 className="mb-4">Why Travelers Choose eSIM? </h4>
            <div className={`${styles.homescroll}  ${styles.Travelersscroll} `}>
              <span>
                <img
                  width="80"
                  height="80"
                  src={Seamless}
                  alt=""
                  
                />
                <label>
                  <h5>Seamless Global Access</h5>
                  <p className="mb-0">
                    Connect instantly in 190+ countries with one-tap eSIM activation
                  </p>
                </label>
              </span>
              <span>
                <img
                  width="80"
                  height="80"
                  src={Seamless1}
                  alt=""
                  
                />
                <label>
                  <h5>AI-Powered Experience</h5>
                  <p className="mb-0">
                    Personalized recommendations and support tailored to your exact needs  
                  </p>
                </label>
              </span>
              <span>
                <img
                  width="80"
                  height="80"
                  src={Seamless2}
                  alt=""
                  
                />
                <label>
                  <h5>Complete Travel Ecosystem</h5>
                  <p className="mb-0">
                   From connectivity to stay and visa assistance—all in one integrated platform 
                  </p>
                </label>
              </span>

              
            
            </div>
          </div>
          <div className="col-md-5 offset-md-1 py-2">
             <div className={styles.Travelerswhy}>
            <img
                className="img-fluid"
                width={100}
                height={100}
                src={freedataim}
                alt=""
                
              />
              </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ChooseSim;
